<template>
  <div class="content-body">
    <div class="container text-start">
      <div class="col-xxl-12">
        <div class="card">
          <div class="card-body">
            <h3 class="animate-characters">Notice</h3>
            <h5 class="text-muted">
              Click the envelope icons to show or hide the sections on this
              page.
            </h5>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h2 v-if="!showTokenomics">
              Surviville Coin Tokenomics &nbsp;
              <a href="#SVC"
                ><i
                  @click="showTokenomics = !showTokenomics"
                  title="Show text"
                  class="ri-mail-line"
                ></i>
              </a>
            </h2>

            <template v-else>
              <h2 id="SVC">
                Surviville Coin Tokenomics &nbsp;
                <a href="#SVC"
                  ><i
                    @click="showTokenomics = !showTokenomics"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h2>
              <ul>
                <h4>
                  Current token amount in existence:
                  <strong>
                    {{ Math.floor(rewardTokenTotalSupply / 10 ** 3) / 10 ** 3 }}
                    million SVC
                  </strong>
                </h4>
                <p class="text-muted">
                  Total maximum supply: <strong>210 million SVC</strong>
                </p>
                <p class="text-muted">
                  The total maximum supply <strong>cannot be exceeded</strong>.
                </p>
                <p class="text-muted">
                  The total maximum supply <strong>cannot be increased</strong>.
                </p>
                <p class="text-muted">
                  <strong>1 million SVC</strong> were minted to the project's
                  wallet at the time the token was created.
                </p>
                <p class="text-muted">
                  The goal was having enough supply to provide initial liquidity
                  for SVC.
                </p>
                <h4>There was <strong>no token presale</strong>.</h4>
                <p class="text-muted">
                  {{ ETH }} for the initial liquidity was taken from the
                  Reaperville mint proceeds.
                </p>
                <h4>There is <strong>no developer tax</strong> on SVC.</h4>
                <h4>
                  <strong>100%</strong> of the SVC that are used for leveling
                  NFTs are <strong>burned</strong>.
                </h4>
              </ul>
              <br />
              <p class="text-muted">
                In addition to the total max. supply mentioned above, each
                collection and subproject of Surviville has their own limits on
                how many SVC they can mint as rewards.
              </p>
              <br />
              <p class="text-muted">
                You can find more details on the already existing subprojects
                and collections below.
              </p>
            </template>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h2 v-if="!showReaperville">
              Reaperville &nbsp;
              <a href="#Reaperville"
                ><i
                  @click="showReaperville = !showReaperville"
                  title="Show text"
                  class="ri-mail-line"
                ></i>
              </a>
            </h2>

            <template v-else>
              <h2 id="Reaperville">
                Reaperville &nbsp;
                <a href="#Reaperville"
                  ><i
                    @click="showReaperville = !showReaperville"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h2>
              <h4 class="mt-4">
                SVC is earnable as a reward token via Reaperville staking:
              </h4>
              <ul>
                <p class="text-muted">
                  <strong>1 million SVC</strong> in the
                  <strong>first year</strong>
                </p>
                <p class="text-muted">
                  <strong>2.5 million SVC</strong> in the
                  <strong>first 3 years</strong>
                </p>
                <p class="text-muted">
                  Lifetime rewards for Reaperville staking are limited to
                  <strong>5 million SVC</strong>
                </p>
              </ul>
              <h5 class="text-muted">
                SVC <strong>minted</strong> as staking rewards:
                <strong>
                  {{ rewardTokenMinted4Reaper }}
                  SVC
                </strong>
                until now
              </h5>
              <h5 class="text-muted">
                SVC <strong>burned</strong> for level upgrades:
                <strong>
                  {{
                    Math.round(
                      1 * 10 ** 6 +
                        rewardTokenMinted4Reaper -
                        rewardTokenTotalSupply
                    )
                  }}
                  SVC
                </strong>
                until now
              </h5>
            </template>

            <h3 class="mt-4" v-if="!showReapervilleRewardTokenEmission">
              Details on SVC Emission from Reaperville Staking &nbsp;
              <a href="#ReapervilleRewardTokenEmission"
                ><i
                  @click="
                    showReapervilleRewardTokenEmission =
                      !showReapervilleRewardTokenEmission
                  "
                  title="Show text"
                  class="ri-mail-line"
                ></i>
              </a>
            </h3>

            <template v-else>
              <h3 class="mt-4" id="ReapervilleRewardTokenEmission">
                Details on Reward Token Emission &nbsp;
                <a href="#ReapervilleRewardTokenEmission">
                  <i
                    @click="
                      showReapervilleRewardTokenEmission =
                        !showReapervilleRewardTokenEmission
                    "
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i>
                </a>
              </h3>

              <p class="text-muted">
                Current Reaperville total emission rate:
                <strong
                  >{{ rewardTokenEmissionPerHour }} SVC / hour @100%
                  payout</strong
                >
              </p>
              <p class="text-muted">
                =
                {{
                  Math.round((rewardTokenEmissionPerHour * 24 * 365) / 1000) /
                  1000
                }}
                million SVC / year
              </p>

              <br />
              <p class="text-muted">
                All incurred penalties for automatic or manual harvests of the
                Reaperville NFT staking reduce the effective emission rate by up
                to 95%.
              </p>
              <br />

              <p class="text-muted">
                If a staker harvests after qualifying for the 15% bonus for
                having staked the Reaperville NFTs for at least 30 days, this
                may increase the effective emission rate by up to 15%.
              </p>

              <br />

              <h4 class="mt-4">
                Total staked power:
                <strong> {{ totalStakedPower }} </strong>🔥
              </h4>
              <template v-if="isAdmin">
                <h4>
                  <p class="text-muted">
                    Base staking power (used to adjust the reward token
                    emission):
                    <strong
                      >{{ baseStakingPower }} ==
                      {{
                        Math.round(
                          (baseStakingPower / totalStakedPower) * 10000
                        ) / 100
                      }}%</strong
                    >
                  </p>
                </h4>
                <h4>Summary of automatic token emission reduction</h4>
                <p>Stake and upgrade add 1% to base staking power</p>
                <p>Unstake adds 5% to base staking power</p>
                <p>Emergency unstake adds 0% to base staking power</p>
                <p>
                  Manual adjustments may be necessary to reach the planned
                  reward token emission
                </p>
              </template>
            </template>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h2 v-if="!showOtherProjects">
              Other Sub-Projects &nbsp;
              <a href="#OtherProjects"
                ><i
                  @click="showOtherProjects = !showOtherProjects"
                  title="Show text"
                  class="ri-mail-line"
                ></i>
              </a>
            </h2>

            <template v-else>
              <h2 id="OtherProjects">
                Other Sub-Projects &nbsp;
                <a href="#Reaperville"
                  ><i
                    @click="showOtherProjects = !showOtherProjects"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h2>
              <p class="text-muted mt-4">
                Information about other sub-projects of the Surviville project
                will be published at a later point.
              </p>
              <br />
              <p class="text-muted">Stay tuned!</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from "ethers";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";
import Reaperville from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";

export default {
  data() {
    return {
      ETH: window.ETH,

      showTokenomics: false,
      showReaperville: false,
      showReapervilleRewardTokenEmission: false,
      showOtherProjects: false,

      contracts: {},

      reaperBchBalance: 0,
      reaperBchPerNft: "0",

      rewardTokenMintAllowance4NewMinter: 10000,
      addressTo: "",

      feedbackMessage: "",

      rewardTokenMintAllowance4Reaper: 0,

      isAdmin: false,

      reaperMintPaused: false,
      reaperStakingPaused: false,

      allowanceToSet: 5000000,
      totalStakedPower: 0,
      baseStakingPower: 0,
      released: 0,
      rewardTokenEmissionPerHour: 0,
      rewardTokenTotalSupply: 0,
      rewardTokenMinted4Reaper: 0,
    };
  },

  mounted: function () {
    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();
        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );
        this.contracts["reaper"] = new ethers.Contract(
          window.ca["reaper"],
          Reaperville.abi,
          this.signer
        );
      })
      .then(() => {
        this.contracts["reaper"]
          .showStakerInfo(window.ca["dev"])
          .then((stakerInfo) => {
            this.totalStakedPower = stakerInfo[2];
            this.baseStakingPower = stakerInfo[3];
            this.rewardTokenEmissionPerHour = String(
              Math.round(ethers.utils.formatEther(stakerInfo[4]) * 100000) /
                100000
            );
          });

        this.contracts["svc"]
          .remainingMintersAllowance(window.ca["reaper"])
          .then((_allowance) => {
            this.rewardTokenMintAllowance4Reaper = String(_allowance);
            this.rewardTokenMinted4Reaper =
              Math.round(
                (5 * 10 ** 24 - Number(this.rewardTokenMintAllowance4Reaper)) /
                  10 ** 15
              ) /
              10 ** 3;
          });

        this.contracts["svc"].totalSupply().then((_totalSupply) => {
          this.rewardTokenTotalSupply = String(
            Math.round(_totalSupply / 10 ** 15) / 10 ** 3
          );
        });
      });
  },
};
</script>
